import filterCase from 'common/filters/filterCase'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

/**
 * Подпись стажа с числом: Vue `tStatic` не подставляет `{age}` из Django-фильтра.
 */
export default function getExperienceLabel(experience: number): string {
  if (experience <= 0) {
    return tStatic('меньше года')
  }

  return `${experience} ${tStatic(filterCase(experience, ['год', 'года', 'лет']))}`
}
